import { IDBPDatabase } from 'idb'

import asyncForEach from 'utils/asyncForEach'

import { IDBSchema } from '../types'

/**
 * CHANGES:
 *
 * - Renamed `openTabs` table to `tabs` table
 * - Save `preview` for every tab
 */

export default (
  database: IDBPDatabase<IDBSchema>,
  transaction: IDBTransaction,
  next: () => void
) => {
  STUDIO_ENV_DEVELOPMENT && console.log('---Running migration for v4---')

  database.createObjectStore('tabs', { keyPath: 'id' })
  STUDIO_ENV_DEVELOPMENT && console.log('Created tabs table')

  const openTabsStore = transaction.objectStore('openTabs')
  const tabsStore = transaction.objectStore('tabs')

  // First, we get all openTabs
  const openTabsRequest = openTabsStore.getAll()
  openTabsRequest.onsuccess = () => {
    const openTabs = openTabsRequest.result
    STUDIO_ENV_DEVELOPMENT && console.log('Found all openTabs', openTabs)

    // Then, copy each openTab to `tabs` table, adding a `preview` field
    asyncForEach(
      openTabs,
      (openTab, next) => {
        if (!openTab.sessionId) {
          return next()
        }
        openTab.preview = false
        STUDIO_ENV_DEVELOPMENT && console.log('Creating new tab', openTab)
        tabsStore.put(openTab).onsuccess = next
      },
      () => {
        // Finally, delete the openTabs table
        database.deleteObjectStore('openTabs')
        STUDIO_ENV_DEVELOPMENT && console.log('Deleted openTabs table')
        STUDIO_ENV_DEVELOPMENT && console.log('---Migrated to v4---')
        return next()
      }
    )
  }
}
